import htmlparser2 from 'react-html-parser';

export const convertHtmlToText = (html: string) => {
  try {
    return htmlparser2(html);
  } catch (e) {
    return '';
  }
};
